
// import React from 'react';
// import { Outlet } from 'react-router-dom';
// import CustomerHeader from '../Layout/CustomerHeader';

// const CustomerLayout = () => {
//   return (
//     <div className="customer-layout">
//       <CustomerHeader />
      
//       <main className="customer-main">
//         <Outlet />
//       </main>
      
//       {/* Fixed: Removed "jsx" attribute and handled string correctly */}
//       <style dangerouslySetInnerHTML={{ __html: `
//         .customer-layout {
//           min-height: 100vh;
//         }
//         .customer-main {
//           padding-top: 80px;
//           background: linear-gradient(135deg, #FAF9F6 0%, #F0F2F5 100%);
//           min-height: calc(100vh - 80px);
//         }
//       ` }} />
//     </div>
//   );
// };

// export default CustomerLayout;

//web view 

import React from 'react';
import { Outlet } from 'react-router-dom';
import CustomerHeader from '../Layout/CustomerHeader';

const CustomerLayout = () => {
  return (
    <div className="customer-layout">
      <CustomerHeader />
      
      <main className="customer-main">
        <Outlet />
      </main>
      
      <style dangerouslySetInnerHTML={{ __html: `
        .customer-layout {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
        }
        .customer-main {
          padding-top: 72px; /* Adjusted base padding for mobile */
          background: linear-gradient(135deg, #FAF9F6 0%, #F0F2F5 100%);
          min-height: calc(100vh - 72px);
          flex: 1;
        }
        @media (min-width: 992px) {
          .customer-main {
            padding-top: 88px; /* Original padding for web view */
            min-height: calc(100vh - 88px);
          }
        }
      ` }} />
    </div>
  );
};

export default CustomerLayout;